<template>
  <v-app
    :key="key"
    :style="{ background: $vuetify.theme.themes[theme].background }"
  >
    <v-app-bar
      v-if="! isWordpressPlugin"
      app
      flat
      dark
      absolute
      :color="$vuetify.theme.themes.dark.background"
    >
      <v-img
        class="mx-2"
        src="/assets/logo/wc_l_logo_light.svg"
        max-height="120"
        max-width="120"
        contain
      />

      <v-spacer />

      <v-btn
        v-if="route().current() === 'faq.lite.edit'"
        small
        color="primary"
        href="#comparison-section"
      >
        Need more features?
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-container
        v-if="flashKey"
        fluid
        :style="route().current() === 'faq.lite.create' ? {
          'position': route().current() === 'faq.lite.create' ? 'absolute' : undefined,
          'max-width': '600px',
          'left': '50%',
          'transform': 'translateX(-50%)'
        } : {}"
      >
        <v-fade-transition hide-on-leave>
          <!-- eslint-disable -->
          <v-alert
            class="mb-0"
            :value="true"
            :type="flashKey"
            dismissible
            @input="handleFlashInput"
          >
            <div v-html="$page.props.flash[flashKey]"></div>
          </v-alert>
          <!-- eslint-enable -->
        </v-fade-transition>
      </v-container>

      <slot />
    </v-main>
  </v-app>
</template>

<script>
import findKey from 'lodash/findKey';

export default {
  props: {
    theme: {
      type: String,
      required: true
    },
    registerUrl: {
      type: String,
      required: false,
      default: null
    }
  },

  data() {
    return {
      key: 0,
      isWordpressPlugin: null
    }
  },

  computed: {
    flashKey() {
      return findKey(this.$page.props.flash, (message) => {
        return message !== null;
      });
    }
  },

  watch: {
    theme: function(value) {
      value === 'dark' ?
        this.$vuetify.theme.dark = true :
        this.$vuetify.theme.dark = false;
      this.key++;
    }
  },

  created() {
    this.theme === 'dark' ?
      this.$vuetify.theme.dark = true :
      this.$vuetify.theme.dark = false;

      const params = new URLSearchParams(window.location.search);
      this.isWordpressPlugin = params.get('wp-plugin') === 'true';
  },

  methods: {
    handleFlashInput(value) {
      if (value === false) {
        this.$page.props.flash[this.flashKey] = null;
      }
    }
  }
}
</script>